export default __webpack_public_path__ + "static/media/anglo-american.a045ab23.png";